<button
    type="button"
    [disabled]="disabled()"
    [class.icon-boundaries]="boundaries() === 'icon'"
    [ngClass]="sizeClass()"
    [class.medium-importance-icon-button]="importance() === 'medium'"
    [class.high-importance-icon-button]="importance() === 'high'"
    [class.on-solid-background]="onSolidBackground()"
>
    @let rawIconColorR = rawIconColor();
    <ui-icon
        [name]="iconName()"
        [iconStyle]="iconStyle()"
        [rawColor]="
            rawIconColorR
                ? rawIconColorR
                : colorPalette()[importance() === 'medium' ? (disabled() ? 8 : onSolidBackground() ? 1 : 11) : 1].solid
        "
        [size]="size()"
    />
</button>
